import React, { Component, Fragment } from "react"
import {
  Row,
  Col,
  FormGroup,
  Button,
  Label,
  Card,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ButtonGroup,
  CardBody,
} from "reactstrap"
import JoditEditor from "jodit-react"
import ListPage from "../../components/custom/ListPage"
import ListPageHeader from "../../components/custom/ListPageHeader"
import { Formik, Form, Field } from "formik"
import { Message } from "helpers/language_helper"
import { MutateRequest, QueryRequest } from "helpers/service_helper"
import { CMSValidation } from "helpers/validations"
import {
  createCMSContentMutation,
  updateCMSContentMutation,
  deleteCMSContentMutation,
  getAllCMSContentQuery,
  getOneCMSContentQuery,
} from "./Queries"
import { Helmet } from "react-helmet-async"
import { ErrorMessage, SuccessMessage } from "helpers/notifications"

class CMSContent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      buttonAction: false,
      isLoading: false,
      isPreview: false,
      pageSizeOptions: [10, 50, 100],
      pageLimit: 10,
      totalCount: 0,
      keyField: "id",
      cmsContentList: [],
      listRequestModel: {
        searchString: "",
        sortCondition: null,
        pageNumber: 1,
        pageLimit: 10,
      },

      cmsContent: {
        name: "",
        content: "",
      },

      columns: [
        {
          name: Message("name"),
          selector: row => row.name,
          sortable: false,
          cell: row => <span>{row.name ? row.name : ""}</span>,
        },
        {
          name: Message("action"),
          selector: row => row.action,
          sortable: false,
          cell: row => (
            <Row>
              <ButtonGroup className="mb-2" style={{ top: "4px" }}>
                <Button
                  outline
                  color="primary"
                  className="mobileViewFont ms-2"
                  onClick={() => this.handleEdit(row)}
                >
                  {Message("edit")}
                </Button>

                {/* <Button
                  outline
                  color="danger"
                  className="mobileViewFonts ps-1 pe-1 ms-2"
                  onClick={() => this.toggleDeleteModal(row)}
                >
                  {Message("delete")}
                </Button> */}
              </ButtonGroup>
            </Row>
          ),
        },
      ],
    }
  }

  componentDidMount() {
    this.getAllCMSContent()
  }
  getAllCMSContent = async value => {
    this.setState({
      isLoading: true,
    })
    const { listRequestModel } = this.state
    var values = listRequestModel
    const response = await QueryRequest(getAllCMSContentQuery, values)
    var cmsContentsValue = response?.data?.getAllCMSContent?.items
    if (cmsContentsValue) {
      this.setState({
        isLoading: false,
        cmsContentList: cmsContentsValue,
        totalPage:
          response?.data?.getAllCMSContent?.pagination?.totalCount /
          response?.data?.getAllCMSContent?.pagination?.pageLimit,
        totalCount: response?.data?.getAllCMSContent?.pagination?.totalCount,
      })
    } else
      this.setState({
        isLoading: false,
      })
  }

  handleEdit = row => {
    if (row) {
      this.setState({
        cmsContent: { id: row.id, name: row.name, content: row.content },
        text: row.content,
        manageModal: !this.state.manageModal,
        isPreview: false,
        Label: "Edit",
      })
    }
  }
  handlePageChange = async page => {
    this.setState(
      {
        pageNumber: page,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageNumber: page,
        },
      },
      function () {
        this.getAllCMSContent()
      }
    )
  }

  handlePerRowsChange = async perPage => {
    this.setState(
      {
        pageLimit: perPage,
        pageNumber: 1,
        listRequestModel: {
          ...this.state.listRequestModel,
          pageLimit: perPage,
          pageNumber: 1,
        },
      },
      async function () {
        this.getAllCMSContent()
      }
    )
  }
  searchQueryChanged = search => {
    this.setState(
      {
        listRequestModel: {
          ...this.state.listRequestModel,
          searchString: search.target.value,
        },
      },
      function () {
        if (
          this.state.listRequestModel.searchString === "" ||
          this.state.listRequestModel.searchString.length > 2
        ) {
          this.getAllCMSContent()
        }
      }
    )
  }
  handleSubmit = values => {
    this.setState({
      buttonAction: true,
    })
    this.manageCMSContent(values)
  }
  manageCMSContent = async values => {
    delete values.id
    setTimeout(() => {
      this.setState({
        buttonAction: false,
      })
    }, 5000)
    if (this.state.Label === "Add")
      await MutateRequest(createCMSContentMutation, { data: values })
        .then(res => SuccessMessage(Message("cmsContent.add")))
        .catch(e => { console.log("hi"); ErrorMessage(e) })
    else {
      let Data = {
        id: this.state.cmsContent.id,
        data: values,
      }
      await MutateRequest(updateCMSContentMutation, Data)
        .then(res => SuccessMessage(Message("cmsContent.update")))
        .catch(e => ErrorMessage(e))
    }

    this.setState({
      manageModal: !this.state.manageModal,
    })
    this.getAllCMSContent()
  }

  deleteCMSContent = async id => {
    var values = {
      id: id,
    }
    const response = await MutateRequest(deleteCMSContentMutation, values)
    var ageGroupMasterdeleteValue = response?.data
    if (ageGroupMasterdeleteValue.deleteOneCMSContent.status === "Success") {
      SuccessMessage(Message("ageGroupMaster.delete"))
      this.getAllCMSContent()
      this.setState({
        buttonAction: false,
        deleteModal: !this.state.deleteModal,
      })
    } else {
      ErrorMessage(Message("api.error"))
      this.setState({
        buttonAction: false,
      })
    }
  }

  addBtnClick = () => {
    this.setState({
      cmsContent: {
        name: "",
        content: "",
      },
      text: "",
      manageModal: !this.state.manageModal,
      isPreview: false,
      Label: "Add",
    })
  }
  toggleManageModal = () => {
    this.setState({
      cmsContent: {
        name: "",
        content: "",
      },
      text: "",
      defaultTemplateResult: "",
      manageModal: !this.state.manageModal,
      isPreview: false,
    })
  }
  toggleDeleteModal = row => {
    this.setState({
      deleteModal: !this.state.deleteModal,
      cmsContent: row,
    })
  }
  showPreview = () => {
    var templateResult = this.state.text
    templateResult = templateResult.replace(/&lt;/g, "<")
    templateResult = templateResult.replace(/&gt;/g, ">")
    this.setState({
      defaultTemplateResult: templateResult,
    })
    this.setState({
      isPreview: !this.state.isPreview,
    })
  }
  render() {
    const INITIALVALUES = this.state.cmsContent
    return (
      <Fragment>
        <Helmet>
          <title>{Message("title.cmsContent")}</title>
        </Helmet>
        <div className="page-content">
          <div className="container-fluid">
            <Card>
              <CardBody>
                <ListPageHeader
                  heading={Message("home.cmsContent")}
                  buttonText={Message("add.cmsContent")}
                  onTextChange={this.searchQueryChanged}
                  buttonClick={this.addBtnClick}
                  searchValue={this.state.listRequestModel.searchString}
                  showButton={false}
                  showSearch={false}
                />
                <ListPage
                  columns={this.state.columns}
                  data={this.state.cmsContentList}
                  keyField={this.state.keyField}
                  totalCount={this.state.totalCount}
                  pageSizeOptions={this.state.pageSizeOptions}
                  rowClicked={this.handleRowClicked}
                  pageLimit={this.state.pageLimit}
                  rowsPerPageOnChange={this.handlePerRowsChange}
                  pageChange={this.handlePageChange}
                  isDataLoading={this.state.isLoading}
                  overFlowXRemoval={true}
                />
              </CardBody>
            </Card>

            <Modal
              isOpen={this.state.deleteModal}
              toggle={this.toggleDeleteModal}
            >
              <ModalHeader toggle={this.toggleDeleteModal}>
                {Message("delete.cmsContent")}
              </ModalHeader>

              <ModalBody>
                <Fragment>
                  <Row className="mb-1 mt-2">
                    <p className="ms-3 me-3 font-size-15">
                      {Message("delete.confirmation")}{" "}
                      <span>
                        {" "}
                        <strong> {this.state.cmsContent?.name}</strong>{" "}
                        {Message("cmsContent")}{" "}
                      </span>
                      ?
                    </p>
                  </Row>
                </Fragment>
              </ModalBody>

              <ModalFooter>
                <FormGroup className="float-sm-right ">
                  <Button
                    type="submit"
                    color="primary"
                    onClick={() =>
                      this.deleteCMSContent(this.state.cmsContent.id)
                    }
                  >
                    {Message("yes")}
                  </Button>
                  <Button
                    color="danger"
                    className="ms-2"
                    onClick={() => this.toggleDeleteModal()}
                  >
                    {Message("no")}
                  </Button>
                </FormGroup>
              </ModalFooter>
            </Modal>
            <Modal
              isOpen={this.state.manageModal}
              toggle={this.toggleManageModal}
              size={"lg"}
            >
              <ModalHeader toggle={this.toggleManageModal}>
                {this.state.Label === "Edit"
                  ? Message("update.cmsContent")
                  : Message("add.cmsContent")}
              </ModalHeader>

              <Formik
                initialValues={INITIALVALUES}
                validationSchema={CMSValidation}
                onSubmit={this.handleSubmit}
                validateOnBlur={false}
                validateOnChange={false}
              >
                {({ errors, values, setFieldValue }) => (
                  <Form className="av-tooltip tooltip-label-bottom">
                    <ModalBody>
                      <Fragment>
                        <Row className="mb-10 ms-2 me-2">
                          <Col lg="12">
                            <Label className="mt-1 requiredField">
                              {Message("name")}
                            </Label>

                            <Field className="form-control" name="name" />
                            {errors.name && (
                              <div className="invalid-feedback d-block">
                                {errors.name}
                              </div>
                            )}
                          </Col>
                        </Row>
                        {this.state.text && (
                          <Row className="mb-10 mt-2 ms-2">
                            <Col xxs="12">
                              {" "}
                              <Button
                                type="button"
                                color="primary"
                                onClick={this.showPreview}
                              >
                                {this.state.isPreview
                                  ? Message("edit")
                                  : Message("preview")}
                              </Button>
                            </Col>
                          </Row>
                        )}
                        <Row className="mb-10 mt-2 ms-2 me-2">
                          {this.state.isPreview ? (
                            <div
                              className="ms-3"
                              dangerouslySetInnerHTML={{
                                __html: this.state.defaultTemplateResult,
                              }}
                            ></div>
                          ) : (
                            <Col lg="12">
                              <Label className="mt-1 requiredField">
                                {Message("content")}
                              </Label>

                              <JoditEditor
                                ref={this.editorRef}
                                name="content"
                                value={this.state.text}
                                onChange={newContent => {
                                  this.setState({ text: newContent })
                                  setFieldValue("content", newContent)
                                }}
                              />

                              {errors.content && (
                                <div className="invalid-feedback d-block">
                                  {errors.content}
                                </div>
                              )}
                            </Col>
                          )}
                        </Row>
                      </Fragment>
                    </ModalBody>
                    <ModalFooter>
                      <FormGroup className="float-sm-right">
                        {this.state.Label === "Edit" ? (
                          <Button
                            className={
                              this.state.buttonAction ? "disabled" : ""
                            }
                            type="submit"
                            color="primary"
                          >
                            {Message("update")}
                          </Button>
                        ) : (
                          <Button
                            className={
                              this.state.buttonAction ? "disabled" : ""
                            }
                            type="submit"
                            color="primary"
                            bg="Primary"
                          >
                            {Message("add")}
                          </Button>
                        )}
                        <Button
                          onClick={() => this.toggleManageModal()}
                          color="danger"
                          className="ms-2 me-3"
                        >
                          {Message("cancel")}
                        </Button>
                      </FormGroup>
                    </ModalFooter>
                  </Form>
                )}
              </Formik>
            </Modal>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default CMSContent
